/* eslint-disable jsx-a11y/anchor-is-valid */
import { FormGroup, Col, ControlLabel, Form, Popover, OverlayTrigger, Button } from 'react-bootstrap';
import { ModalGeneral } from '../../shared/ModalGeneralComponent';
import { BranchesSelector } from '../ui/branchesSelector';

export class AppointmentLocation extends React.Component {
  /**
   * Constructor de la clase AppointmentLocation.
   * @param {object} props - Propiedades del componente React.
   */
  constructor(props) {
    super(props);
    this.state = {
      latitude: 0,
      longitude: 0,
      locationItems: [],
      showCloserLocations: false,
      enableGeoSearch: false,
      messageModal: '',
      iconoModal: '',
      colorIco: '',
      noX: '',
      noAceptar: '',
      noCancelar: '',
      titleModal: '',
    };
    this.getLocation = this.configureGeolocation.bind(this);
    this.asin = Math.asin;
    this.cos = Math.cos;
    this.sin = Math.sin;
    this.sqrt = Math.sqrt;
    this.PI = Math.PI;

   
    this.R = 6378137;
  }

  /**
   * Ciclo de vida de React: se ejecuta después de montar el componente.
   * Inicializa la obtención de la ubicación.
   */
  componentDidMount() {
    this.getLocation();
  }

  /**
   * Muestra el modal general con los parámetros dados.
   * @param {string} title - Título del modal.
   * @param {string} message - Mensaje del modal.
   * @param {string} icono - Icono del modal.
   * @param {string} colorIco - Color del icono.
   * @param {string} noX - Indica si se muestra la X de cerrar.
   * @param {string} noAceptar - Indica si se muestra el botón aceptar.
   * @param {string} noCancelar - Indica si se muestra el botón cancelar.
   */
  activeModal(title, message, icono, colorIco, noX, noAceptar, noCancelar) {
    this.setState({
      titleModal: title,
      messageModal: message,
      iconoModal: icono,
      colorIco: colorIco,
      noX: noX,
      noAceptar: noAceptar,
      noCancelar: noCancelar,
    });
    this.refs.activeModal.handleShow();
  }

  /**
   * Configura y solicita la geolocalización del usuario usando la API del navegador.
   */
  configureGeolocation() {
    var locationTimeout = parseInt(parseText('Form.AppointmentLocation.LastLocationExpiryTimeout'));
    var gpsTimeOut = parseInt(parseText('Form.AppointmentLocation.LastLocationExpiryTimeout'));
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (position !== null && position !== undefined) {
            this.setState({
              enableGeoSearch: true,
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          }
        },
        (locationError) => {
          var LocationErrorCodes = {
            PERMISSION_DENIED: 1,
            POSITION_UNAVAILABLE: 2,
            TIMEOUT: 3,
          };
          switch (locationError.code) {
            case LocationErrorCodes.TIMEOUT: {
              this.setState({
                enableGeoSearch: true,
              });
              console.log('Se produjo un timeout obteniendo la posicion usando gps');
              break;
            }
            case LocationErrorCodes.PERMISSION_DENIED: {
              this.showErrorMessage(
                parseText('Form.AppointmentLocation.GeolocationNotAuthorized'),
                parseText('sharedResources.Modal.Bolean.False'),
                parseText('sharedResources.Modal.Bolean.False'),
              );
              break;
            }
            case LocationErrorCodes.POSITION_UNAVAILABLE: {
              console.log('No se pudo obtener la ubicacion', locationError.message);
              break;
            }
            default: {
              console.log('Error de la geolocalizacion ' + locationError.message);
              break;
            }
          }
        },
        { maximumAge: locationTimeout, timeout: gpsTimeOut },
      );
    } else {
      console.log('No funciona la geolocalizacion en este navegador');
    }
  }

  /**
   * Filtra y muestra las sedes cercanas según la distancia en metros.
   * @param {number} distance - Distancia máxima en metros.
   */
  getPlacesNearToM(distance) { 
    document.getElementById('btnNearTo').classList.remove('btn-primary');
    document.getElementById('btnNearTo').classList.add('btn-default');
    document.getElementById('btnChangeToPlaces').classList.remove('btn-default');
    document.getElementById('btnChangeToPlaces').classList.add('btn-primary');
    if (
      this.props.AppointmentLocations !== null &&
      this.props.AppointmentLocations !== undefined &&
      this.props.AppointmentLocations.length !== 0
    ) {
      const distance = this.getDistanceParam(); //distance in M
      const filteredLocations = this.filterLocationBasedOnDistanceM(distance);
      if (filteredLocations !== undefined && filteredLocations !== null) {        
        if (filteredLocations.length > 0) {
          this.getFriendlyLocationItems(filteredLocations);
        } else if (filteredLocations.length === 0) {
          this.getFriendlyLocationItems(this.props.baseBranches);
        }
      }
    } else {
      console.log('Error obteniendo las sedes');
    }
  }

  /**
   * Calcula el cuadrado de un número.
   * @param {number} x - Número a elevar al cuadrado.
   * @returns {number} Resultado de x^2.
   */
  squared(x) {
    return x * x;
  }
  /**
   * Convierte grados a radianes.
   * @param {number} x - Valor en grados.
   * @returns {number} Valor en radianes.
   */
  toRad(x) {
    return (x * this.PI) / 180.0;
  }

  /**
   * Calcula la función haversine para un ángulo dado.
   * @param {number} x - Ángulo en radianes.
   * @returns {number} Valor haversine.
   */
  hav(x) {
    return this.squared(this.sin(x / 2));
  }


  /**
   * Calcula la distancia haversine entre dos puntos geográficos.
   * @param {object|array} a - Primer punto (objeto o array [lng, lat]).
   * @param {object|array} b - Segundo punto (objeto o array [lng, lat]).
   * @returns {number} Distancia en metros.
   */
  haversineDistance(a, b) {
    const aLat = this.toRad(Array.isArray(a) ? a[1] : a.latitude || a.lat);
    const bLat = this.toRad(Array.isArray(b) ? b[1] : b.latitude || b.lat);
    const aLng = this.toRad(Array.isArray(a) ? a[0] : a.longitude || a.lng || a.lon);
    const bLng = this.toRad(Array.isArray(b) ? b[0] : b.longitude || b.lng || b.lon);

    const ht = this.hav(bLat - aLat) + this.cos(aLat) * this.cos(bLat) * this.hav(bLng - aLng);
    return 2 * this.R * this.asin(this.sqrt(ht));
  }

  /**
   * Obtiene la distancia de referencia en metros desde la configuración.
   * @returns {number} Distancia en metros.
   */
  getDistanceParam() {
    const refDistance = parseText('Form.AppointmentLocation.DefaultDistanceMeters');
    const distance = parseFloat(refDistance);
    return distance;
  }

  /**
   * Filtra las sedes según la distancia máxima permitida.
   * @param {number} distance - Distancia máxima en metros.
   * @returns {array} Sedes filtradas.
   */
  filterLocationBasedOnDistanceM(distance) {
    const filteredLocations = this.props.AppointmentLocations.filter((locationItem) => {
      const currDist = this.haversineDistance(
        [this.state.latitude, this.state.longitude],
        [Number(locationItem.Latitude), Number(locationItem.Longitude)],
      ); //en Metros
      return currDist <= distance;
    });
    return filteredLocations;
  }

  /**
   * Muestra todas las sedes disponibles sin filtrar por distancia.
   */
  getAppointmentLocationItemsBasedInGeoLocation() {
    document.getElementById('btnChangeToPlaces').classList.remove('btn-primary');
    document.getElementById('btnChangeToPlaces').classList.add('btn-default');

    document.getElementById('btnNearTo').classList.remove('btn-default');
    document.getElementById('btnNearTo').classList.add('btn-primary');
    if (
      this.props.AppointmentLocations !== null &&
      this.props.AppointmentLocations !== undefined &&
      this.props.AppointmentLocations.length !== 0
    ) {
      this.getFriendlyLocationItems(this.props.AppointmentLocations);
    } else {
      console.log('Error obteniendo las sedes');
    }
  }

  /**
   * Convierte las sedes en un formato amigable para el dropdown y actualiza el estado.
   * @param {array} locationItems - Lista de sedes.
   */
  getFriendlyLocationItems(locationItems) {
    //para consultarTelexperticia es otro servicio
    const arr = [1189, 1193, 1099, 1134, 1191, 1192, 2018, 5030, 10006, 0];
    const set = new Set(arr);
    var items = [];
    if (locationItems !== null && locationItems !== undefined) {
      for (var i = 0; i < locationItems.length; i++) {
        var locationItem = locationItems[i];
        if (locationItem !== null && locationItem !== undefined && !set.has(locationItem.Code)) {
          var item = {
            id: locationItem.Code,
            value: locationItem.InternalCode,
            text: locationItem.Name,
            url: locationItem.BranchUrl,
            address: locationItem.Address,
          };
          items.push(item);
        }
      }
      this.setState({
        locationItems: items,
        showCloserLocations: true,
      });
    }
  }

  /**
   * Muestra un mensaje de error en el modal general.
   * @param {string} errorMsg - Mensaje de error.
   * @param {string} showbtnAceptar - Mostrar botón aceptar.
   * @param {string} showbtnCerrar - Mostrar botón cerrar.
   */
  showErrorMessage(errorMsg, showbtnAceptar, showbtnCerrar) {
    return this.activeModal(
      'Error en el sistema',
      errorMsg,
      parseText('sharedResources.Iconos.Error'),
      parseText('sharedResources.Colores.Azul'),
      parseText('sharedResources.Modal.Bolean.True'),
      showbtnAceptar,
      showbtnCerrar,
    );
  }

  /**
   * Callback para manejar los ítems seleccionados en el dropdown.
   * @param {array} checked - Ítems seleccionados.
   */
  getChecked(checked) {
    this.props.itemChecked(checked);
  }

  /**
   * Renderiza el componente de selección de sede para la cita médica.
   * @returns {JSX.Element} Elementos JSX a renderizar.
   */
  render() {
    const tooltip = (
      <Popover id="tooltip" title="">
        <strong>{parseText('Form.AppointmentLocation.LocationTooltipContent')}</strong>
      </Popover>
    );
    return (
      <div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 box-background-gray" id="selectDropDownValidation">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-form-select-content">
            <h4>{parseText('Form.AppointmentLocation.Header')}</h4>
            <hr />
          </div>

          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-select-content">          
            {this.props.oneBranche && (
                console.log('AppointmentLocations oneBranche:', this.props.AppointmentLocations),
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h4>Solo hay una sede disponible para esta especialidad.</h4>
                {
                  <h4>
                    {this.props.AppointmentLocations && this.props.AppointmentLocations[0]
                      ? this.props.AppointmentLocations[0].Name
                      : ''}
                  </h4>
                }
              </div>
            )}          
            {!this.props.oneBranche && (
              <Form horizontal>
                <FormGroup controlId="formControlsSelect">
                  <Col componentClass={ControlLabel} sm={12} md={3} lg={3}>
                    <ControlLabel>{parseText('Form.AppointmentLocation.LocationLabel')}</ControlLabel>
                  </Col>
                  <Col sm={12} md={5} lg={4}>
                    <div className="col-xs-11 col-sm-11 col-md-11 col-lg-11">
                      <a
                        className="btn btn-default"
                        id="btnNearTo"
                        onClick={(e) => {
                          e.preventDefault();
                          this.getPlacesNearToM(100000);
                        }}
                        disabled={!this.state.enableGeoSearch}
                      >
                        {parseText('Form.AppointmentLocation.CloserToMyLocationLabel')}
                      </a>
                    </div>
                    <div className="col-sm-1 col-md-1 col-lg-1 location-info-icon">
                      <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={tooltip}>
                        <a className="iconPromotionBtn">
                          <i className="fa fa-exclamation-circle"></i>
                        </a>
                      </OverlayTrigger>
                    </div>
                  </Col>
                  <Col componentClass={ControlLabel} sm={3} md={3}>
                    <Button
                      className="btn btn-primary marginButton"
                      id="btnChangeToPlaces"
                      disabled={false}
                      onClick={this.getAppointmentLocationItemsBasedInGeoLocation.bind(this)}
                    >
                      {parseText('Form.AppointmentLocation.AvailablePlacesButtonText')}
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            )}
          </div>
        </div>
        <div style={{ display: this.state.showCloserLocations ? 'block' : 'none' }}>
          <BranchesSelector
            checkedSedes={this.getChecked.bind(this)}
            PlaceHolderText={parseText('Form.AppointmentLocation.SelectLocationLabel')}
            ListItems={this.state.locationItems}
          />
        </div>
        <ModalGeneral
          MessageTitle={this.state.titleModal}
          msg={this.state.messageModal}
          Icono={this.state.iconoModal}
          NoX={this.state.noX}
          NoAceptar={this.state.noAceptar}
          NoCancelar={this.state.noCancelar}
          colorIco={this.state.colorIco}
          AltButtonText={parseText('sharedResources.Modal.Buttons.Aceptar')}
          MainButtonText={parseText('sharedResources.Modal.Buttons.Cancelar')}
          ref="activeModal"
          MainButtonAction={this.handleModalCancel}
          AltButtonAction={this.handleModalConfirm}
        />
      </div>
    );
  }
}
